module.exports = __webpack_public_path__ + "static/media/results.c6f5650f.png";